import { NAVIGATOR_CONFIG } from "../../headless/children";
function StackHeaderSearchBar(_props) {
  return null;
}
Object.assign(StackHeaderSearchBar, {
  [NAVIGATOR_CONFIG]: true
});
function appendStackHeaderSearchBarPropsToOptions(options, props) {
  return {
    ...options,
    headerSearchBarOptions: props
  };
}
export {
  StackHeaderSearchBar,
  appendStackHeaderSearchBarPropsToOptions
};
//# sourceMappingURL=StackHeaderSearchBar.js.map
